/**
 * BatchGeoCopyMachine allows you to "override" content for the user to copy
 * with some browser trickery. Override in quotes because you're not actually
 * overriding what the user is copying but we take the content you provide,
 * create a hidden textarea, put that content in it and highlight that content.
 * Then, when the user presses cmd/ctrl+c they're copying the hidden content.
 *
 * It also provides a way to trigger the copy using a newer browser API called
 * execCommand. Warning: execCommand is finicky.
 *
 * To get all these tricks to work THIS MODULE IS ASYNC EXCEPT FOR TRIGGERED
 * COPIES VIA `autoCopy`. For example, if autoCopy is off the highlight doesn't
 * take affect until 10ms after it's called. Same with destroy. The textarea
 * is not removed for 10ms.
 */
window.BatchGeoCopyMachine = (function () {
  var _copy = function () {
    try {
      document.execCommand("copy");
    } catch (err) {
      console.log(err);
    }
  };
  return function CopyMachineInstance() {
    // Creates and hides the textarea behind the page
    // NOTE: The autocomplete, autocorrect, autocapitalize, and spellcheck
    // properties turned off are for performance. If these are not disabled and
    // and this textarea gets a lot of content (say 10,000 lines) the browser
    // will lockup as all of these native functions run.
    var $copyAreaElement = $(
      '<textarea autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />',
    ).css({
      position: "absolute",
      zIndex: "-1",
    });

    // Put it right at the top of the document
    $copyAreaElement.prependTo(document.body);

    // Public API
    return {
      /**
       * Will copy or set the string returned in the prepFunction param. If the
       * autoCopy param is true (its false by default) it *try* to automatically
       * copy to the user's clipboard.
       *
       * NOTE: For autoCopy to work it is NOT async and for non-autoCopy to work
       * it IS async.
       *
       * @param  {function} prepFunction A function to run before a copy happens
       *                    for you to set the content.
       * @param  {boolean}  autoCopy      If true it will attempt to copy
       *                    directly to the user's clipboard. Otherwise it will
       *                    just secrely highlight the hidden textarea for cmd+c
       * @return {undefined}
       */
      copyContents: function (prepFunction, autoCopy) {
        $copyAreaElement.val(prepFunction());
        if (autoCopy) {
          $copyAreaElement.select();
          _copy();
        } else {
          setTimeout(function () {
            $copyAreaElement.select();
          }, 10);
        }
      },
      /**
       * Removes the textarea and will call a callback after it's done since
       * it's async.
       *
       * @param  {function} afterDestroy called after the textarea is removed
       * @return {undefined}
       */
      destroy: function (afterDestroy) {
        afterDestroy = afterDestroy || function () {};

        setTimeout(function () {
          $copyAreaElement.remove();
          afterDestroy.call(this);
        }, 10);
      },
    };
  };
})();
